import React from "react";

import "./InitialFormStyleSheet.css";

function InitialChannelHeader(props) {
  const onClose = () => {
    window.parent.postMessage(
      {
        iframeMinimized: 'true'
      },
      "*"
    )

    if (typeof props?.actions?.onHideChatWindow === 'function') {
      props.actions.onHideChatWindow();
    }
  };







  return (
    <div className="s360-initial-channel-header" style={props.config?.customDesign?.initialFormHeader}>
      <div className="s360-initial-form-header-message">
        <div className="s360-initial-form-header-salutation-message" style={props.config?.customDesign?.initialFormHeaderMessage}>
          <h4>
            {props.config.configDetails.brandMessage.toString()}
          </h4>
          <div className="s360-default-header-icon" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13.624"
              height="53"
              viewBox="0 0 13.624 8.209"
            >
              <path
                id="down-arrow"
                d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                transform="translate(-2364.171 -5054.96)"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="s360-initial-form-header-welcome-message" style={props.config?.customDesign?.initialFormHeaderMessage}>
        {props.config.configDetails.brandWelcomeMessage}
      </div>
      <div className="s360-initial-channel-sub-header-message" style={props.config?.customDesign?.initialChannelSubHeader}>
        {props.config.configDetails.brandChannelSubMessage}
      </div>
    </div>
  );
}

export default InitialChannelHeader;
